import React, { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { Container } from '../../styles/Styles';
import { CONFIRM_PASSWORD_RESET } from '../gql/auth-gql';
import Loader from '../common/Loader';

const ResetPasswordContainer = styled.div`
    max-width: 400px;
    margin: 2rem auto;
    padding: 2rem;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-align: center;
`;

const Title = styled.h2`
    margin-bottom: 1.5rem;
    color: #333;
`;

const Message = styled.p`
    color: #666;
    margin-bottom: 1rem;
`;

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();

    const [confirmPasswordUpdate, { loading }] = useMutation(CONFIRM_PASSWORD_RESET, {
        onCompleted: () => {
            toast.success('Your password has been successfully updated.');
            navigate('/');
        },
        onError: (error) => {
            toast.error(error.message || 'Failed to update password. The link may have expired.');
            navigate('/');
        }
    });

    useEffect(() => {
        if (token) {
            confirmPasswordUpdate({
                variables: {
                    token,
                    newPassword: '' // Backend will handle the password update
                }
            });
        } else {
            toast.error('Invalid reset link');
            navigate('/');
        }
    }, [token, confirmPasswordUpdate, navigate]);

    if (loading) {
        return (
            <Container>
                <ResetPasswordContainer>
                    <Loader />
                    <Message>Verifying your password reset request...</Message>
                </ResetPasswordContainer>
            </Container>
        );
    }

    return (
        <Container>
            <ResetPasswordContainer>
                <Title>Password Reset</Title>
                <Message>Please wait while we process your request...</Message>
            </ResetPasswordContainer>
        </Container>
    );
};

export default ResetPassword; 